import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../error_boundary";
import GetQwotedCTA from "../profiles/GetQwotedCTA";
import ProductShow from "./show";
import { ProductContextProvider } from "./data/product_context_management";

function ProductTopLevelShow({ productId, userId = undefined, viewerContext = undefined }) {
  const contextValue = { productId, userId, viewerContext };

  return (
    <ProductContextProvider value={contextValue}>
      <ErrorBoundary>
        <ProductShow productId={productId} userId={userId} />
      </ErrorBoundary>
      {!viewerContext?.isAuthenticated && <GetQwotedCTA />}
    </ProductContextProvider>
  );
}

ProductTopLevelShow.propTypes = {
  productId: PropTypes.string.isRequired,
  userId: PropTypes.string,
  viewerContext: PropTypes.shape({
    editable: PropTypes.bool,
    isSelf: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    role: PropTypes.string,
  }),
};

export default ProductTopLevelShow;
